import styles from './info-popup.module.scss';
import { CrossIcon } from '../icons/icons';
import React, { CSSProperties, useCallback, useRef, useState } from 'react';
import useOnClickOutside from '../../../hooks/use-on-click-outside.hook';
import colorStyle from '../../../styles/utils/variables.module.scss';

export type Props = {
  heading?: string;
  children: React.ReactNode;
  onClose: () => void;
  cssClass: string; // for positioning on desktop
  customStyle?: CSSProperties | null; // used for edge cases
  hideOnTab?: boolean;
};

export default function InfoPopup({ children, onClose, heading, cssClass, customStyle, hideOnTab }: Props) {
  // this one for closing animation
  const [closing, setClosing] = useState<boolean>(false);

  const popupRef = useRef(null);

  const closePopup = useCallback(() => {
    setClosing(true);
    // delaying closing to make animation work
    setTimeout(onClose, 150);
  }, [onClose]);

  useOnClickOutside(popupRef, closePopup, hideOnTab);

  return (
    <div
      className={`${styles['popup-wrapper']} ${closing ? styles.closing : ''}  ${cssClass}`}
      style={customStyle}
      aria-live='polite'
      aria-atomic
    >
      <div
        className={styles.popup}
        role='tooltip'
        aria-describedby='info-popup-content'
        aria-labelledby='info-popup-header'
        ref={popupRef}
      >
        <div className={styles['popup-header']}>
          <h6 id='info-popup-header'>{heading}</h6>
          <button
            className={styles['popup-close']}
            aria-label='Close info popup button'
            autoFocus
            onClick={closePopup}
          >
            <CrossIcon fillColor={colorStyle.grey3} height={24} width={24} />
          </button>
        </div>
        <div id='info-popup-content' className={styles['popup-content']} tabIndex={-1}>
          {children}
        </div>
      </div>
    </div>
  );
}
